/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * EClass API
 * API to fetch eClass data by ID
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type { GetEClassResponse, GetEclassDataByIdBody } from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get eClass Data By ID
 */
export const getEclassDataById = (
  getEclassDataByIdBody: GetEclassDataByIdBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetEClassResponse>(
    {
      url: `/api/v2/eclasses/get/get-eclass-data-by-id`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getEclassDataByIdBody,
      signal,
    },
    options,
  );
};

export const getGetEclassDataByIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getEclassDataById>>,
    TError,
    { data: GetEclassDataByIdBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getEclassDataById>>,
  TError,
  { data: GetEclassDataByIdBody },
  TContext
> => {
  const mutationKey = ["getEclassDataById"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getEclassDataById>>,
    { data: GetEclassDataByIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return getEclassDataById(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetEclassDataByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof getEclassDataById>>
>;
export type GetEclassDataByIdMutationBody = GetEclassDataByIdBody;
export type GetEclassDataByIdMutationError = void;

/**
 * @summary Get eClass Data By ID
 */
export const useGetEclassDataById = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getEclassDataById>>,
      TError,
      { data: GetEclassDataByIdBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getEclassDataById>>,
  TError,
  { data: GetEclassDataByIdBody },
  TContext
> => {
  const mutationOptions = getGetEclassDataByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
